import React, {useContext} from "react";
// Importing Widgets
import { FormRow } from "../../../common/containers/formContainer";
import { PendingTransactions, ApprovedScheduled, RejectedInvoices, DueMonth, OverDueMonth, DisbursementsGraph, MappedDebtors, AwaitingPayments, ApprovedScheduledSummary, AdvancedSummary } from "../../widgets/IFTransWidgets";
import authService from "../../../../services/authService";
import EntityContext from "../../../../context/entityContext";
import AccountingSoftware from "../../components/accountingSoftware/index";
import useWidgetReload from "../../../../hooks/useWidgetReload";


function    InvoiceSnapshot() {

    const { constants } = authService.getCurrentUser();
    const { entityDetails } = useContext(EntityContext);

    const { reloadKey, reloadWidgets } = useWidgetReload();

    return (
        <>
            <FormRow>
                <PendingTransactions reloadKey={reloadKey} />
                {/* <AwaitingPayments />
                <ApprovedScheduled /> */}
                <ApprovedScheduledSummary reloadKey={reloadKey}/>
                <AdvancedSummary reloadKey={reloadKey}/>
            </FormRow>

            <FormRow>

                {/* <DisbursementsGraph /> */}
                <div className="col-md-8 col-sm-8 col-xs-6 col-12">
                    <AccountingSoftware
                        entityGuid={entityDetails.a_guid}
                        product = {constants.PRODUCTS.INVOICE}  
                        onWidgetReload={reloadWidgets}
                    />
                </div>
                
                <div className="col-md-4 col-sm-4 col-xs-2 col-12">
                    
                        <DueMonth reloadKey={reloadKey}/>                        
                   

                    <FormRow>
                        <OverDueMonth reloadKey={reloadKey}/>
                    </FormRow>

                    <FormRow>
                        <MappedDebtors />
                    </FormRow>

                    <FormRow>
                        <RejectedInvoices />
                    </FormRow>

                </div>
            </FormRow>
        </>
    )
}
export default InvoiceSnapshot;